if (!customElements.get('product-card-slider')) {
  customElements.define(
    'product-card-slider',
    class ProductCardSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sliderInstance = false;
        this.paginationType = this.dataset.paginationType || 'bullets';
        
        // Only initialize on mobile if purely controlled by CSS display, 
        // but it's safer to check if we are visible or if the element exists.
        // However, since we are wrapping this in a `md:hidden` block in Liquid,
        // it will be in the DOM.
        // We can initialize it always, Swiper handles resize.
        // Or we can initialize only if window width is < 768px.
        
        this.init();
      }

      init() {
          this.initSlider();
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        this.sliderOptions = {
          slidesPerView: 1,
          spaceBetween: 0,
          navigation: false,
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            type: this.paginationType,
            clickable: true
          },
          loop: true,
          threshold: 2,
        };

        this.classList.add('swiper');
        // The wrapper and slides are expected to be set up in Liquid
        
        if (window.FoxTheme && window.FoxTheme.Carousel) {
             this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
             this.sliderInstance.init();
        } else {
            // Fallback if FoxTheme is not ready immediately?
            // Usually assets are loaded in head or at end of body.
            // We might need to wait for DOMContentLoaded or similar if FoxTheme is not defined.
            document.addEventListener('DOMContentLoaded', () => {
                if (window.FoxTheme && window.FoxTheme.Carousel && typeof this.sliderInstance !== 'object') {
                    this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
                    this.sliderInstance.init();
                }
            });
        }
      }

      disconnectedCallback() {
        if (this.sliderInstance && this.sliderInstance.slider) {
            this.sliderInstance.slider.destroy();
        }
      }
    }
  );
}
